<div class="pauta div-expand" [ngClass]="{'print-page':print}">
  <h3>Pauta</h3>
  <h1>{{description}}</h1>
  <hr class="space-expand">
  <article>
    <div class="d-flex mb-3">
      <h3>Órgãos</h3>
      <button class="btn carousel-control prev" (click)="previous()" [disabled]="!canGoPrevious">
        <span class="icon">arrow_back</span>
      </button>
      <button class="btn carousel-control next" (click)="next()" [disabled]="!canGoNext">
        <span class="icon">arrow_forward</span>
      </button>
    </div>
    <div class="carousel" 
      #carousel 
      (mousedown)="startDrag($event)" 
      (mousemove)="onDrag($event)" 
      (mouseup)="endDrag()"
      (mouseleave)="endDrag()">
      <section *ngFor="let agency of entity?.agencyPf"  class="div-expand">
        <b>{{agency.str_nome}}</b>
        <hr class="space-expand">
        <div class="div-timer">
          <div class="timer">
            <span class="icon">schedule</span>
            {{ getMinutes(agency) | date:'HH:mm:ss':'UTC' }}
          </div>
        </div>
      </section>
    </div>
  </article>

</div>
<app-loading [loader]="isLoading"></app-loading>
